import { memo } from "react";
import Screen, { type ScreenProps } from "ui/layouts/Screen";
import Transactions from "ui/organizms/Transactions";

const TransactionsScreen = (props: ScreenProps) => (
    <Screen
        {...props}
        title='Transactions'
    >
        <Transactions />
    </Screen>
);

export default memo(TransactionsScreen);
